export const TRANSCRIPT_FONT_FAMILIES = [
    'sans-serif',
    'serif',
    'monospace',
    'opendyslexic',
    'open-sans',
    'roboto',
    'gelasio',
];
/** CSS stack for the OpenDyslexic option (font shipped via @fontsource/opendyslexic). */
export const OPENDYSLEXIC_CSS_STACK = "'OpenDyslexic', sans-serif";
/**
 * CSS stacks for the self-hosted faces (@fontsource, SIL OFL 1.1). Each names
 * its generic family as the fallback for the moment before the font file
 * arrives. Gelasio is the open stand-in for Georgia (proprietary, not ours to
 * ship): it is metric-compatible with it, so a locally installed Georgia is
 * the closest fallback.
 */
const LOADED_FACE_STACKS = {
    opendyslexic: OPENDYSLEXIC_CSS_STACK,
    'open-sans': "'Open Sans', sans-serif",
    roboto: "'Roboto', sans-serif",
    gelasio: "'Gelasio', Georgia, serif",
};
/**
 * CSS `font-family` value for a stored transcript font setting. The generic
 * families are their own CSS value; the named faces map to their loaded stack.
 */
export function cssFontFamily(fontFamily) {
    return LOADED_FACE_STACKS[fontFamily] ?? fontFamily;
}
/**
 * Normalise a font-family value read from storage.
 *
 * Before 2026-08-27 the OpenDyslexic option stored the raw CSS stack
 * (`'OpenDyslexic', sans-serif`) while the type only allowed the generic
 * families — and no font file was shipped, so the choice silently fell back
 * to sans-serif. Accept that legacy value as `opendyslexic`, keep any valid
 * family, and fall back to sans-serif for anything else.
 */
export function normalizeFontFamily(value) {
    if (value === OPENDYSLEXIC_CSS_STACK)
        return 'opendyslexic';
    if (typeof value === 'string' &&
        TRANSCRIPT_FONT_FAMILIES.includes(value)) {
        return value;
    }
    return 'sans-serif';
}
//# sourceMappingURL=font-family.js.map